import { render } from "./MWithdrawalDetails.vue?vue&type=template&id=574c3ecc&scoped=true"
import script from "./MWithdrawalDetails.vue?vue&type=script&lang=js"
export * from "./MWithdrawalDetails.vue?vue&type=script&lang=js"

import "./MWithdrawalDetails.vue?vue&type=style&index=0&id=574c3ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574c3ecc"]])

export default __exports__